import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type { OnlineUsersDatatableInput, OnlineUsersDto } from '@/api/types/onlineUsers';

// Routes derived from ABP conventional-controller mapping of
// Finkit.Host.OnlineUsers.OnlineUsersAppService:
//   GetListForDataTableAsync -> GET /api/app/online-users/for-data-table
const BASE = '/api/app/online-users';

export const onlineUsersApi = {
  async getListForDataTable(
    input: OnlineUsersDatatableInput,
  ): Promise<PagedResult<OnlineUsersDto>> {
    const { data } = await http.get<PagedResult<OnlineUsersDto>>(`${BASE}/for-data-table`, {
      params: input,
    });
    return data;
  },
};
